import { QueryClient } from '@tanstack/react-query'

/**
 * Single shared QueryClient for the customer app.
 *
 * Defaults tuned for a portal that doesn't change under the user's feet -
 * long stale time, no window-focus refetch, one retry. Individual queries
 * override where they need fresher data.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})
